import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id C72FF17B-D0E1-4641-9802-B6BA993D5910
 * name anvil
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/anvil.svg
 * tags
 */
export const AnvilIcon = createSvgIcon(<><path d="M9,5V10C13.03,12.47 8.44,14.97 6,16V19H21V16C14.59,13.27 17.47,9 22,8V5H9M2,6C2.81,8.13 4.42,9.5 7,10V6H2Z" /></>, 'AnvilIcon');
export default AnvilIcon